const binding = { modules: {}, dataActions: {} };

    (binding.modules['copyright'] = {
        c: () => require('partner/modules/copyright/copyright.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'copyright',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/copyright'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };